import WebGalleryTitleBreadcrumb from './WebGalleryTitleBreadcrumb';

export default WebGalleryTitleBreadcrumb;
